import React from 'react'
import Header from '../Header'
import Sidebar from '../Sidebar'

const TransactionDetails = () => {
  return (
    <>
    <Header/>
    <Sidebar/>
        <main className="main" id="main">
        <div className='page-title'>TransactionDetails</div>
        <div className="container">
            <div className="row">
                <div className="col-lg-8">
                    <div className="card">
                    <div className="card-body">
                    <h2 className='card-title'>Transaction Details</h2>
      <p className='card-text'>Transaction ID: 123</p>
      <p className='card-text'>Date: 12-8-23</p>
      <p className='card-text'>Amount: $2000</p>
      </div>
                    </div>
                </div>
            </div>
        </div>
        </main>
    </>
    
  )
}

export default TransactionDetails